import { useTranslations } from '@vocab/react';
import {
  Box,
  Card,
  ContentBlock,
  Heading,
  Stack,
  Text,
} from 'braid-design-system';
import React from 'react';

import translations from './.vocab';
import { CustomerServiceMessage } from './CustomerServiceMessage/CustomerServiceMessage';
import { PlugIcon } from './PlugIcon';
import { useAppContext } from 'src/App/context/AppContext';

export const ErrorPage = () => {
  const { t } = useTranslations(translations);
  const { site } = useAppContext();

  return (
    <ContentBlock width="small">
      <Card>
        <Box textAlign="center" paddingY="large">
          <Stack space="medium" align="center">
            <PlugIcon />
            <Heading level="3">{t("It's not you, it's us")}</Heading>
            <Stack space="medium">
              <Text>{t("We've experienced a technical error...")}</Text>
              <Text>{t('Please try again')}</Text>
              <CustomerServiceMessage site={site} />
            </Stack>
          </Stack>
        </Box>
      </Card>
    </ContentBlock>
  );
};
